/* eslint-disable react/jsx-no-useless-fragment */
import { Pagination, Spin } from 'antd';
import React from 'react';
import { fetchProyecto } from '../../actions/proyecto';
import Accordion from '../../components/accordion';
import Bread from '../../components/breadcrumb';
import Card from '../../components/card';
import { usePagination } from '../../hooks/usePagination';
import { columnsProyecto, parserDataTabla } from '../../utils/parsers/table';
import { routeProyecto } from '../../utils/routesBread';
import AccordionProyecto from './accordion-proyecto';

const Proyecto = () => {
  const {
    dataSource, total, handlePage, page, isLoading
  } = usePagination(fetchProyecto, 'proyecto');

  return (
    <div className="page-container">
      <div className="header-nav">
        <Bread routes={routeProyecto} />
      </div>
      <div className="page-container__box">
        <Accordion keyPanel="proyectos" header="Proyectos">
          {isLoading
            ? (
              <div className="container-spin">
                <Spin tip="Cargando..." />
              </div>
            )
            : (
              <>
                {dataSource
              && dataSource.length !== 0 ? (
                    dataSource.map((item) => (
                      <div key={item.nombre}>
                        <Card
                          columns={columnsProyecto}
                          data={[parserDataTabla(item)]}
                          header={item.nombre}
                          route="info-proyecto"
                        />
                        <AccordionProyecto data={item} />
                      </div>
                    ))
                  ) : <p className="text-nothing">No hay datos para mostrar</p>}
              </>
            )}
        </Accordion>
        {dataSource
        && (
        <div className="page-container__pagination">
          <Pagination current={page} onChange={handlePage} total={total} />
        </div>
        )}
      </div>
    </div>
  );
};

export default Proyecto;
